import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
    // linkActiveClass: 'is-active',
    mode: 'history',
    base: '/kaweb_beta/',
    routes
  })
  
//   router.beforeEach(initCurrentUserStateMiddleware)
//   router.beforeEach(checkAccessMiddleware)
//   router.beforeEach(setPageTitleMiddleware)
  
  export default router